import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { NavbarComponent } from '../navbar/navbar.component'

// Shell do Portal do Fornecedor: mesma navbar do sistema, sem a sidebar —
// o perfil 12 só enxerga esse portal, então a sidebar padrão não faz sentido aqui.
@Component({
  selector: 'supplier-portal-layout',
  imports: [RouterOutlet, NavbarComponent],
  templateUrl: './supplier-portal-layout.component.html',
  styleUrl: './supplier-portal-layout.component.scss',
})
export class SupplierPortalLayoutComponent {}
